import React, { useEffect } from 'react';
import ParityFilterInput from '@app/model/parity/input/ParityFilterInput';
import CalendarRange from '@app/state/calendar/CalendarRange';
import moment from 'moment';
import Utilities from '@util/Utilities';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import DashboardSelectCalendarMonthFilter
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/filters/DashboardSelectCalendarMonthFilter';
import {
	useMarketStateTools,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useMarketStateTools';
import DashboardSelectRatesTypeFilter
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/filters/DashboardSelectRatesTypeFilter';
import DashboardSelectNightsFilter
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/filters/DashboardSelectNightsFilter';
import {
	ParityFilterAirportCodeCheckFilter,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__parity/fragment/ParityFilterAirportCodeCheckFilter';
import {
	ParityFilterAirportCodesCompareFilter,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__parity/fragment/ParityFilterAirportCodesCompareFilter';
import Tag from '@app/component/tag/Tag';


const ParityFiltersHeaderFragment: React.FunctionComponent<{
	companyHotel: CompanyHotel
	setRange: (range: CalendarRange) => void,
	filter: ParityFilterInput,
	setFilter: (filter: ParityFilterInput) => void,
}> = ({ companyHotel, setRange, filter, setFilter }) => {

	const tools = useMarketStateTools();

	useEffect(() => {
		if (!!tools.calendarMonth) {
			const date = moment(new Date(tools.calendarMonth.index.year, Utilities.getMonthOrdinal(tools.calendarMonth.index.month), 1));
			setRange({
				startStatDate: date.startOf('month').format('YYYY-MM-DD'),
				endStatDate: date.endOf('month').format('YYYY-MM-DD'),
			});
		}
	}, [tools.calendarMonth]);


	return <div className="bg-white shadow-sm border-t border-gray-200">
		<div className="mx-auto max-w-7xl py-3 px-4 sm:px-6 lg:px-8">
			<div className="md:flex md:items-center md:justify-between gap-x-4">
				<DashboardSelectCalendarMonthFilter />
				{companyHotel.hasParityModule() && !companyHotel.hasRatesModule() &&
					<div className="flex flex-wrap gap-x-2 gap-y-2 items-center">
						<span className="text-sm font-semibold leading-6 text-gray-900">Filters</span>
						<div className="h-4 w-px bg-gray-300 mx-1 hidden sm:block"></div>
						<DashboardSelectNightsFilter filter={filter} onFilter={setFilter} />
						<div>
							<Tag state='slate' extraClassName=" px-4 py-2">Lowest</Tag>
						</div>
						<div>
							<Tag state='slate' extraClassName=" px-4 py-2">Any Room</Tag>
						</div>
						<div>
							<Tag state='slate' extraClassName=" px-4 py-2">Any Meal</Tag>
						</div>
						<div>
							<Tag state='slate' extraClassName=" px-4 py-2">{filter.guests} Guests</Tag>
						</div>
					</div>}

				{companyHotel.hasRatesModule() && <div className="flex flex-wrap gap-x-2 gap-y-2 items-center">
					<span className="text-sm font-semibold leading-6 text-gray-900">Filters</span>
					<div className="h-4 w-px bg-gray-300 mx-1 hidden sm:block"></div>
					<DashboardSelectRatesTypeFilter filter={filter} onFilter={setFilter} overrideDefaultConfiguration={{enabled: true}}/>
					<DashboardSelectNightsFilter filter={filter} onFilter={setFilter}  overrideDefaultConfiguration={{enabled: true}}/>
					<span className="mx-3 hidden sm:block"></span>
					<span className="text-sm font-semibold leading-6 text-gray-900">Flights:</span>
					<div className="h-4 w-px bg-gray-300 mx-1 hidden sm:block"></div>
					<ParityFilterAirportCodeCheckFilter filter={filter} onFilter={setFilter} />
					<ParityFilterAirportCodesCompareFilter filter={filter} onFilter={setFilter} />
				</div>}
			</div>
		</div>
	</div>;
};

export default ParityFiltersHeaderFragment;